/**
 * Small React error boundary. Wraps any component whose exceptions would
 * otherwise crash the whole page. Renders a graceful fallback with a retry.
 */
import { Component } from "react";
import { AlertTriangle } from "lucide-react";

export default class ErrorBoundary extends Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false, error: null };
  }

  static getDerivedStateFromError(error) {
    return { hasError: true, error };
  }

  componentDidCatch(error, info) {
    // eslint-disable-next-line no-console
    console.error("[ErrorBoundary]", error, info);
  }

  reset = () => this.setState({ hasError: false, error: null });

  render() {
    if (!this.state.hasError) return this.props.children;
    return (
      <div
        data-testid="error-boundary-fallback"
        className="rounded-md border border-[#FF003C]/40 bg-[#FF003C]/[0.06] p-6 text-center"
      >
        <AlertTriangle className="mx-auto h-6 w-6 text-[#FF003C]" />
        <p className="mt-3 text-sm text-white">
          Something went wrong loading this section.
        </p>
        <p className="mt-1 text-[11px] text-white/60">
          {String(this.state.error?.message || this.state.error || "")}
        </p>
        <button
          data-testid="error-boundary-reset"
          onClick={this.reset}
          className="mt-4 rounded-full border border-gold/50 px-6 py-2 text-[10px] uppercase tracking-[0.2em] text-gold hover:bg-gold hover:text-ink"
        >
          Try again
        </button>
      </div>
    );
  }
}
